/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsChangePlanGet200ResponseOneOf1 model module.
 * @module model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1
 * @version 1.0.0
 */
class CustomersSubscriptionsChangePlanGet200ResponseOneOf1 {
    /**
     * Constructs a new <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code>.
     * @alias module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1
     */
    constructor() { 
        
        CustomersSubscriptionsChangePlanGet200ResponseOneOf1.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsChangePlanGet200ResponseOneOf1} The populated <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsChangePlanGet200ResponseOneOf1();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'String');
            }
            if (data.hasOwnProperty('subscriptionId')) {
                obj['subscriptionId'] = ApiClient.convertToType(data['subscriptionId'], 'String');
            }
            if (data.hasOwnProperty('hasPendingChangePlan')) {
                obj['hasPendingChangePlan'] = ApiClient.convertToType(data['hasPendingChangePlan'], 'Boolean');
            }
            if (data.hasOwnProperty('currentBundle')) {
                obj['currentBundle'] = ApiClient.convertToType(data['currentBundle'], 'String');
            }
            if (data.hasOwnProperty('targetBundle')) {
                obj['targetBundle'] = ApiClient.convertToType(data['targetBundle'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsChangePlanGet200ResponseOneOf1</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['customerId'] && !(typeof data['customerId'] === 'string' || data['customerId'] instanceof String)) {
            throw new Error("Expected the field `customerId` to be a primitive type in the JSON string but got " + data['customerId']);
        }
        // ensure the json data is a string
        if (data['subscriptionId'] && !(typeof data['subscriptionId'] === 'string' || data['subscriptionId'] instanceof String)) {
            throw new Error("Expected the field `subscriptionId` to be a primitive type in the JSON string but got " + data['subscriptionId']);
        }
        // ensure the json data is a string
        if (data['currentBundle'] && !(typeof data['currentBundle'] === 'string' || data['currentBundle'] instanceof String)) {
            throw new Error("Expected the field `currentBundle` to be a primitive type in the JSON string but got " + data['currentBundle']);
        }
        // ensure the json data is a string
        if (data['targetBundle'] && !(typeof data['targetBundle'] === 'string' || data['targetBundle'] instanceof String)) {
            throw new Error("Expected the field `targetBundle` to be a primitive type in the JSON string but got " + data['targetBundle']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['email'] = undefined;

/**
 * @member {String} customerId
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['customerId'] = undefined;

/**
 * @member {String} subscriptionId
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['subscriptionId'] = undefined;

/**
 * @member {Boolean} hasPendingChangePlan
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['hasPendingChangePlan'] = undefined;

/**
 * @member {String} currentBundle
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['currentBundle'] = undefined;

/**
 * @member {String} targetBundle
 */
CustomersSubscriptionsChangePlanGet200ResponseOneOf1.prototype['targetBundle'] = undefined;






export default CustomersSubscriptionsChangePlanGet200ResponseOneOf1;

